import { useEffect } from "react";
import { useReadPageAclQuery } from "./acl.endpoint";
import { skipToken } from "@reduxjs/toolkit/query";

export const useReadAclQuery = <T>(pageUrl: string | typeof skipToken) => {
  const {
    data,
    isLoading: isAclLoading,
    refetch,
  } = useReadPageAclQuery(pageUrl);

  useEffect(() => {
    if (pageUrl !== skipToken) {
      void refetch();
    }
  }, [refetch, pageUrl]);

  return { acl: data as T | null, isAclLoading, refetch };
};
